import { ActionsUnion, createAction } from '../_commons/actions.common';
import { JobOffer } from './jobOffers.state';

export enum JobOffersActionTypes {
    GET_JOB_OFFER_STARTED = 'JOB_OFFERS_GET_JOB_OFFER_STARTED',
    GET_JOB_OFFER_FINISHED = 'JOB_OFFERS_GET_JOB_OFFER_FINISHED',
    GET_JOB_OFFER_FAILED = 'JOB_OFFERS_GET_JOB_OFFER_FAILED'
}

export const JobOffersActions = {
    getJobOfferStarted: () => createAction(JobOffersActionTypes.GET_JOB_OFFER_STARTED),
    getJobOfferFinished: (response: GetJobOfferFinishedParams) =>
        createAction(JobOffersActionTypes.GET_JOB_OFFER_FINISHED, { response }),
    getJobOfferFailed: (error: string, httpStatus?: number) =>
        createAction(JobOffersActionTypes.GET_JOB_OFFER_FAILED, { error, httpStatus })
};

interface GetJobOfferFinishedParams {
    id: string;
    offer: JobOffer;
}

export type JobOffersAction = ActionsUnion<typeof JobOffersActions>;
